import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomLoaderComponent } from './custom-loader.component';

@NgModule({
  declarations: [CustomLoaderComponent],
  imports: [
    CommonModule,
  ],
  exports: [CustomLoaderComponent],
})
export class CustomLoaderModule { }
